import React from 'react';

import { Meta } from '$partials/global';
import * as Pages from './union';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').UnionPage}
 */
const UnionPage = (props) => {
    if (!props.data?.page?.__typename || typeof (Pages[props.data?.page?.__typename]) === 'undefined') {
        return null;
    }

    const Component = Pages[props.data?.page?.__typename];

    return (
        <>
            <Meta
                description={props.data?.page?.searchDescription || props.data?.page?.listingText}
                domain={props.domain}
                image={props.data?.page?.listingImage}
                page={props.data?.page} />
            <Component { ...props } />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default UnionPage;
